/* eslint-disable no-undef */
import axios from 'axios';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import getImageReaderBaseUrl from './imageReaderUrl';
import { loadState } from '../store/browserStorage';
import { VITE_IMAGE_READER_DATAPOWER_API, VITE_AUTH_HEADER_PREFIX, VITE_GP_VERSION_DATAPOWER_API } from 'Constants/appEnvConstants';

const baseUrl = getImageReaderBaseUrl();

export function getImageDataForCaseNumber(caseNumber, documentTypes) {
  configureHttpHeaders(axios);
  return get(`api/v1/imagereader/case/${caseNumber}/image`, documentTypes);
}

export function apiDownloadDocument(base64Images, fileName) {
  const headers = configureHttpHeadersForDataPowerAPI(axios);
  return postBlob(VITE_IMAGE_READER_DATAPOWER_API, { fileName: fileName, base64Images }, headers);
}

export function getImageByDocumentId(documentId, caseNumber) {
  configureHttpHeaders(axios);

  return getImage(`api/v1/imagereader/image/documentid/${documentId}`, caseNumber);
}

function getImage(url, caseId) {
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  return axios.get(`${baseUrl}${url}?caseNumber=${caseId}`).then(onSuccess).catch(onError);
}

function get(url, searchInputDetails) {
  let pathVariables = '';
  let separator = '';
  // eslint-disable-next-line no-restricted-syntax, guard-for-in, no-unused-vars
  for (const key in searchInputDetails) {
    pathVariables = `${pathVariables + separator + key}=${searchInputDetails[key]}`;
    separator = '&';
  }
  return axios.get(`${baseUrl}${url}?${pathVariables}`).then(onSuccess).catch(onError);
}

function postBlob(url, responseBody, headers) {
  return axios({
    method: 'post',
    url: `${url}`,
    data: responseBody,
    responseType: 'blob',
    headers: headers,
  })
    .then(onSuccess)
    .catch(onError);
}
function configureHttpHeadersForDataPowerAPI() {
  /* eslint-disable no-param-reassign, dot-notation */
  const auth = loadState('auth');
  let accessToken = auth && auth.accessToken;
  if (accessToken) {
    accessToken = VITE_AUTH_HEADER_PREFIX + accessToken;
  } else {
    accessToken = '';
  }

  return {
    Accept: 'text/csv,application/pdf,application/json',
    Authorization: accessToken,
    'x-gp-version': VITE_GP_VERSION_DATAPOWER_API,
  };
}

export default {
  getImageDataForCaseNumber,
  getImageByDocumentId,
  apiDownloadDocument,
};
